import _ from 'underscore';

import { TagsHelper } from '~src/tags/TagsInputHelper';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITagsParams } from '../../../spacesPlatform/utils/actionParams';

export class RemoveTagsFromDatasourcesRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    // The server returns quoted tags unquoted.  This re-adds the double quotes if needed
    const tagsList = _.map(tags, (tag: string) => TagsHelper.quote(tag));

    super('removeTagsFromDatasources', {
      ids: ids,
      tags: tagsList
    });
  }
}
